import { EcommerceAPI } from "../Client";

const getChildPayload = (payload = {}) => {
  if (payload?.dto) return payload.dto;

  const { offeringId, ...childPayload } = payload;
  return childPayload;
};

export const postOfferingChildrenApi = async (payload = {}) => {
  try {
    const response = await EcommerceAPI.post(
      `/offering/children?offeringId=${payload?.offeringId || ""}`,
      getChildPayload(payload)
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateOfferingChildrenApi = async (payload = {}) => {
  try {
    const response = await EcommerceAPI.put(
      `/offering/children?offeringId=${payload?.offeringId || ""}`,
      getChildPayload(payload)
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteOfferingChildrenApi = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload;
    const response = await EcommerceAPI.delete(`/offering/children?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getOfferingChildrenApi = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload;
    const response = await EcommerceAPI.get(`/offering/children/${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getAllOfferingChildrenApi = async (payload = {}) => {
  try {
    const offeringId = payload?.offeringId ?? payload;
    const response = await EcommerceAPI.get(
      `/offering/children/all?offeringId=${offeringId || ""}`
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};
